import {userConstants} from '../_constants';

export function searchStatus(state = {}, action) {
    switch (action.type) {
        case userConstants.SET_SEARCH_IN_PROGRESS:
            return {
                loading: true,
                searchString: action.data,
            };
        case userConstants.SET_SEARCH_CATALOG_IN_PROGRESS:
            return {
                loading: true,
                searchString: action.data,
                catalog: true
            };
        case userConstants.SET_SEARCH_PROMO_IN_PROGRESS:
            return {
                loading: true,
                searchString: action.data,
                promo: true,
            };



        case userConstants.SEARCH_FINAL:
            return {
                ...state,
                loading: false,
            };


        case userConstants.SEARCH_DONE:
            return {
                ...state,
                // loading: false,
            };
        case userConstants.SEARCH_CATALOG_DONE:
            return {
                ...state,
                loading: false,
            };
        case userConstants.SEARCH_PROMO_DONE:
            return {
                ...state,
                loading: false,
            };


        case userConstants.GET_SEARCH_PANEL_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
}
